'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = typeof window !== 'undefined';
var debug = require('../../utils/debug');
var getQuery = require('../../utils/get_query');
var storage = isClient ? require('@ali/simple-storage') : {};
var doShortenLink = require('./shortlink');

// 根据相关参数生成分享内容跟分享链接
module.exports = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(config) {
    var _config, shareType, scene, _config$query, query, isLocalePath, _require, getRandom, getHref, getLocale, _getLocale, _getLocale$title, title, _getLocale$img, img, _getLocale$desc, desc, __tidx, __iidx, __didx, linkEntryConfig, _config2, _config2$sharePath, sharePath, link, redirectLink, _ref2, __tspec, __dspec, __ispec, shareContent;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 复制一份，以免玷污数据
            config = (0, _assign2.default)({}, config);
            _config = config, shareType = _config.__shareType, scene = _config.scene, _config$query = _config.query, query = _config$query === undefined ? {} : _config$query, isLocalePath = _config.isLocalePath;
            _require = require('../../utils/index'), getRandom = _require.getRandom, getHref = _require.getHref;
            getLocale = require('../../utils/get_locale');

            // 获取巴别塔对应的分享文案

            _getLocale = getLocale(scene), _getLocale$title = _getLocale.title, title = _getLocale$title === undefined ? '' : _getLocale$title, _getLocale$img = _getLocale.img, img = _getLocale$img === undefined ? '' : _getLocale$img, _getLocale$desc = _getLocale.desc, desc = _getLocale$desc === undefined ? '' : _getLocale$desc;

            if (title) {
              _context.next = 8;
              break;
            }

            debug('[share] \u6587\u6848 ' + scene + ' \u4E0D\u5B58\u5728\uFF0C\u8BF7\u68C0\u67E5');
            throw new Error('Scene does not exist. Please check the config.');

          case 8:

            // 随机文案处理
            __tidx = 0, __iidx = 0, __didx = 0;


            if (Array.isArray(title)) {
              __tidx = getRandom(0, title.length - 1);
              title = title[__tidx];
            }

            if (Array.isArray(img)) {
              __iidx = getRandom(0, img.length - 1);
              img = img[__iidx];
            }

            if (Array.isArray(desc)) {
              __didx = getRandom(0, desc.length - 1);
              desc = desc[__didx];
            }

            linkEntryConfig = getLocale('share_control.link_entry');

            if (linkEntryConfig === 'share_control.link_entry') {
              linkEntryConfig = '';
            }

            // 默认分享路径为index
            _config2 = config, _config2$sharePath = _config2.sharePath, sharePath = _config2$sharePath === undefined ? 'index' : _config2$sharePath;

            if (isLocalePath) {
              sharePath = window.location.pathname.split('/').pop();
            }

            // 随机文案，还需要在链接中加入随机索引值参数，因为爬虫对同一条链接只抓取一次，所以随机值在客户端实现，在node端再获取对应的文案即可
            link = getHref(sharePath, (0, _extends3.default)({
              entry: shareType + 'share' + linkEntryConfig,
              __scene: scene,
              __entryChain: '' + (getQuery('__entryChain') || getQuery('entry')) + shareType + 'share' + linkEntryConfig, // 分享传播链路参数
              __tidx: __tidx,
              __iidx: __iidx,
              __didx: __didx,
              __v: getLocale('version'), // 获取版本号，用于清除更新巴别塔文案后，存在的缓存
              forcela: getAppLang(), // 分享语言
              lange: getQuery('lange')
            }, query.link));

            // 如果需要短链，先转一次

            if (!config.isShortLink) {
              _context.next = 21;
              break;
            }

            _context.next = 20;
            return doShortenLink(link, config);

          case 20:
            link = _context.sent;

          case 21:
            redirectLink = getHref(sharePath, (0, _extends3.default)({
              entry: 'shareRedirectLink',
              __scene: scene,
              lange: getQuery('lange'),
              __entryChain: (getQuery('__entryChain') || getQuery('entry')) + 'shareRedirectLink', // 分享传播链路参数
              forcela: getAppLang() }, query.redirect));

            // __tspec， __dspec, __ispec最高优先级

            _ref2 = query.link || {}, __tspec = _ref2.__tspec, __dspec = _ref2.__dspec, __ispec = _ref2.__ispec;

            __tspec ? title = __tspec : null;
            __dspec ? desc = __dspec : null;
            __ispec ? img = __ispec : null;
            // 存在替换规则
            title = replaceShareContent(title, query.link);
            desc = replaceShareContent(desc, query.link);

            shareContent = { title: title, img: img, desc: desc, link: link, redirectLink: redirectLink, __tidx: __tidx, __iidx: __iidx, __didx: __didx };

            debug('[share] 最终分享值：', shareContent);
            return _context.abrupt('return', shareContent);

          case 31:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

function getAppLang() {
  return storage.getCookie('forcela') || storage.getCookie('firstput') || getQuery('forcela') || getQuery('lange') || window.__intl__ && window.__intl__.locale || '';
}

function replaceShareContent(content, query) {
  var replaceReg = /{(\s*)(\w+)(\s*)}/g;
  return content.replace(replaceReg, function (match, p1, p2) {
    if (query && query[p2]) {
      return query[p2];
    }
    return match;
  });
}